import { HardDrive } from 'lucide-react';

import { ContainerListViewModel } from '@/react/docker/containers/types';

import { DetailsTable } from '@@/DetailsTable';
import { Widget, WidgetTitle, WidgetBody } from '@@/Widget';

interface Props {
  mounts: ContainerListViewModel['Mounts'] | undefined;
}

export function VolumesTable({ mounts = [] }: Props) {
  if (mounts.length === 0) {
    return null;
  }

  return (
    <div className="row">
      <div className="col-sm-12">
        <Widget>
          <WidgetTitle title="Volumes" icon={HardDrive} />
          <WidgetBody className="!pb-0 !pt-2">
            <DetailsTable
              headers={['Host/Volume', 'Path in container']}
              dataCy="volumes-table"
            >
              {mounts.map((mount) => {
                const name = mount.Type === 'bind' ? mount.Source : mount.Name;
                if (!name) {
                  return null;
                }

                return (
                  <DetailsTable.Row label={name} key={name}>
                    {mount.Destination}
                  </DetailsTable.Row>
                );
              })}
            </DetailsTable>
          </WidgetBody>
        </Widget>
      </div>
    </div>
  );
}
